export const getOptionalParamFromKey = (
  optionalParams: string[],
  paramKey: string
): string | undefined =>
  optionalParams
    .find((param) => param.startsWith(`${paramKey}=`))
    ?.split('=')[1] ?? undefined;
